// extracted by mini-css-extract-plugin
export default {"oosNotify":"Q9-z","count":"R9-z","otherColors":"S9-z","modalContent":"T9-z","body":"U9-z"};